import React from "react";
import ReactQuill from "react-quill";
import EditorToolbar, { modules, formats } from "./EditorToolbar";
import "react-quill/dist/quill.snow.css";
import "./style.css";

export const Editor = ({body, setBody}) => {
  return (
    <div className="text-editor">
      <EditorToolbar />
      <ReactQuill
        theme="snow"
        value={body}
        onChange={(e) => setBody(e)}
        placeholder={"Write Your Blog awesome..."}
        modules={modules}
        formats={formats}
      />
    </div>
  );
};

export default Editor;
